import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import {
  useNavigate,
  useParams
} from 'react-router-dom';

export type RemoveInstallationFormProps = {
  id: string;
  handleClose: () => void;
  preventNavigation?: boolean;
};

export const FC = (props: RemoveInstallationFormProps) => {
  const navigate = useNavigate();
  const params = useParams();
  const [
    fnRemoveInstallationForm,
    { loading }
  ] = ds.useRemoveInstallation();

  const handleSubmit = async (id: string, projectId: string) => {

    await fnRemoveInstallationForm(id, projectId);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(props.id, params.projectId ?? '');
        if (!props.preventNavigation) {
          navigate('..');
        }

      }}
      cancelButtonText='Cancel'
      successButtonText='Remove'
      isLoading={loading}
    >
      <></>
    </FormBaseLayout.FC>

  );
};
